import state from "./moduleComplaintSuggestionState.js";
import mutations from "./moduleComplaintSuggestionMutations.js";
import actions from "./moduleComplaintSuggestionActions.js";
import getters from "./moduleComplaintSuggestionGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  isRegistered: false,
};
